import * as React from 'react';
import { route } from '../../utils/route';
import { trackSignupClicked } from '../../utils/tracking';

interface FinalCTAProps {
  loginUrl: string;
  whatsappUrl: string;
  promoDiscount: number;
  title: string;
  subtitle: string;
}

export function FinalCTA({ whatsappUrl, promoDiscount, title, subtitle }: FinalCTAProps) {
  return (
    <section className="gastro-final-cta">
      <style>{`
        .gastro-final-cta {
          padding: 80px 24px;
          background: #1a1a1a;
          text-align: center;
        }
        .gastro-final-inner {
          max-width: 640px;
          margin: 0 auto;
        }
        .gastro-final-cta h2 {
          font-size: 28px;
          font-weight: 800;
          color: #fff;
          margin: 0 0 12px;
        }
        .gastro-final-cta p {
          font-size: 18px;
          color: rgba(255,255,255,0.75);
          margin: 0 0 36px;
        }
        .gastro-final-ctas {
          display: flex;
          gap: 16px;
          justify-content: center;
          flex-wrap: wrap;
        }
        .gastro-final-promo {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          margin-top: 20px;
          padding: 10px 20px;
          background: rgba(30, 170, 37, 0.2);
          border: 1px solid rgba(30, 170, 37, 0.5);
          border-radius: 8px;
          color: #6ee674;
          font-size: 15px;
          font-weight: 500;
        }
        .gastro-final-promo strong {
          color: #fff;
          font-weight: 700;
        }
        .gastro-final-whatsapp {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          margin-top: 16px;
          color: rgba(255,255,255,0.6);
          font-size: 14px;
          text-decoration: none;
          transition: color 0.2s;
        }
        .gastro-final-whatsapp:hover {
          color: #25d366;
          text-decoration: none;
        }
        @media (max-width: 640px) {
          .gastro-final-cta {
            padding: 60px 24px;
          }
          .gastro-final-cta h2 {
            font-size: 24px;
          }
          .gastro-final-ctas {
            flex-direction: column;
            align-items: stretch;
          }
          .gastro-final-ctas a {
            justify-content: center;
          }
          .gastro-final-promo {
            display: block;
            text-align: center;
          }
        }
      `}</style>
      <div className="gastro-final-inner">
        <h2>{title}</h2>
        <p>{subtitle}</p>
        <div className="gastro-final-ctas">
          <a href={route('wholesale.pricing')} className="gastro-btn-primary">
            <i className="fa fa-list-alt" /> Ver Precios Mayoristas
          </a>
          <a href={route('company.create')} className="gastro-btn-secondary" onClick={() => trackSignupClicked('gastronomicos', 'footer')}>
            <i className="fa fa-user-plus" /> Crear una cuenta mayorista
          </a>
        </div>
        <div className="gastro-final-promo">
          <i className="fa fa-star" /> Tu primer mes con <strong>{promoDiscount}% de descuento</strong> en todos los productos
        </div>
        <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="gastro-final-whatsapp">
          <i className="fa fa-whatsapp" /> ¿Dudas? Escribinos por WhatsApp
        </a>
      </div>
    </section>
  );
}
